{
  "colorSwatchPicker": "Színtárak",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Válasszon ki egy elemet",
  "tableResizer": "Átméretező"
}
